import add_csrf_token_to_request_data from "../support/csrf";

export default function init() {
    init_event_listeners();
}

function init_event_listeners() {
    $("span.question-form-show").on("click", function () {
        $(this).hide();
        $("div.question-form").show().find("input[type=text]").focus();
    });

    $("span.question-answer-form-show").on("click", function () {
        let $self = $(this);
        $self.hide();
        $("#" + $self.data("target")).show().find("textarea").focus();
    });

    $("span.questions-trigger").on("click", function () {
        if (!window.confirm("Sicher?")) {
            return;
        }

        let $trigger = $(this);
        let data = {
            action: $trigger.data("action"),
            type: $trigger.data("type"),
            id: $trigger.data("id")
        };
        data = add_csrf_token_to_request_data(data);

        $.post(
            '/admin/article_questions/status.json',
            data,
            function () {
                window.location.reload();
            }
        );
    });
}
